import store from '../store';
import { getSrchParams } from '../actions/search-actions';
import moment from 'moment';
import { refreshPage, setCookie } from './helper';

const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// export function getColors(val) {
//     switch (val) {
//         case 0:
//             return color0;
//         case 1:
//             return color1;
//         default:
//             return color0;
//     }
// }

export function findKey(obj, val, param) {
    var key = null;
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            if ((param !== false && obj[prop][param] === val) || obj[prop] === val) {
                key = prop;
            }
        }
    }
    return key;
}

export function isInteger(num) {
    return (num % 1) === 0;
}

export function getSearchParams() {
    const myObj = {};
    const param = decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false;
    const pairs = param.split('&');
    for (let i = 0; i < pairs.length; i++) {
        pairs[i] = pairs[i].split('=');
        if (pairs[i][0] == 'fromCity' || pairs[i][0] == 'toCity') {
            pairs[i][1] = pairs[i][1].replace(/\+/g, ' ');
        }
        myObj[pairs[i][0]] = pairs[i][1].trim();
    }

    store.dispatch(getSrchParams(myObj));
    return myObj;
}

export function removeObjInArr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i] && arr[i].hasOwnProperty(attr) &&
            (arguments.length > 2 && arr[i][attr] === value)) {
            arr.splice(i, 1);
        }
    }
    return arr;
}

export function getDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    return Math.floor(diff / 60) + ':' + (diff % 60) + 'HRS';
}

export function getStaDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    const hour = Math.floor(diff / 60);
    const min = (diff % 60);
    const actHr = hour < 10 ? "0" + hour : hour;
    const actMin = min < 10 ? "0" + min : min;
    return actHr + ':' + actMin + ' Hrs';
}

export function get24HrTime(val) {
    val = getISOstring(val);
    const dt = new Date(val);
    const hrs = dt.getHours();
    const mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
}
export function get12to24hourtme(time) {
    var PM = time.match('PM') ? true : false;
    time = time.split(/[ :]+/)
    var min = time[1]
    var hour = ""
    if (PM) {
        hour = 12 + parseInt(time[0], 10)
    } else {
        hour = time[0]
    }
    return hour + ':' + min;
}

export function getRevDate(val) {
    return val ? val.split('-')[2] + '-' + val.split('-')[1] + '-' + val.split('-')[0] : null;
}

export function getDateFormatted(val) {
    val = getRevDate(val);
    const dt = new Date(val);
    const day = dayShort[dt.getDay()];
    const dateVal = dt.getDate();
    const month = monthShort[dt.getMonth()];
    const year = (dt.getFullYear() + '').substr(2);
    return day + ', ' + (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month + ' ' + year;
}
export function getDateFormatted2(val) {
    val = getISOstring2(val); //works for only date in 02-jul-2021 format
    const dt = new Date(val);
    const dateVal = dt.getDate();
    const month = monthShort[dt.getMonth()];
    const year = dt.getFullYear();
    return (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month + ' ' + year;
}

export function getDateFormatted3(val) {
    val = getISOstring2(val); //works for only date in 02-jul-2021 format
    const dt = new Date(val);
    const dateVal = dt.getDate();
    const month = monthShort[dt.getMonth()];
    const dayNmae = dayShort[dt.getDay()];
    return dayNmae + ' ' + (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month;
}

export function getDateFormatted4(val) {
    val = getISOstring2(val); //works for only date in 02-jul-2021 format
    const dt = new Date(val);
    const dateVal = dt.getDate();
    const month = monthShort[dt.getMonth()];
    const year = dt.getFullYear();
    return (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month;
}

export function getDateForSrch(val) {
    const dt = new Date(val);
    const dateVal = dt.getDate();
    const month = dt.getMonth() + 1;
    const year = dt.getFullYear();
    return (dateVal < 10 ? '0' + dateVal : dateVal) + '-' + (month < 10 ? '0' + month : month) + '-' + year;
}

export function getPointTime(val) {
    val = val.split(' ');
    val[1] = val[1].split(':')[0] + ':' + val[1].split(':')[1];
    return val[1] + ' ' + val[2];
}

export function fetchGet(url) {
    return fetch(url).then(function (response) {
        return response.json();
    }).then(function (data) {
        return data;
    })
}

export function fetchPost(url, postData) {
    let params = new FormData();
    Object.keys(postData).forEach(el => {
        params.append(el, postData[el]);
    });

    return fetch(url, {
        body: params,
        method: 'POST',
        mode: 'cors'
    }).then(function (response) {
        return response.json();
    }).then(function (data) {
        return data;
    })
}

export function get12hoursTime(val) {
    var temp = val.split(/[^0-9]/);
    var dt = new Date(temp[0], temp[1] - 1, temp[2], temp[3], temp[4], temp[5]);
    var hrs = dt.getHours() <= 12 ? dt.getHours() : (12 - dt.getHours() > 0 ? 12 - dt.getHours() : dt.getHours() - 12);
    var mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + (dt.getHours() < 12 ? ' AM' : ' PM');
}

export function get24hoursTime(val) {
    var temp = val.split(/[^0-9]/);
    var dt = new Date(temp[0], temp[1] - 1, temp[2], temp[3], temp[4], temp[5]);
    var hrs = dt.getHours();
    var mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
}
export function getFormattedTime(val) {
    if (window.msurl === 'lavibus.com' || window.msurl === 'gptmohantravels.com') {
        return get12hoursTime(val);
    }
    return get24hoursTime(val);
}
export function getFormattedDayDate(val) {
    val = val.split(/[^0-9]/);
    const dt = new Date(val[0], val[1] - 1, val[2], val[3], val[4], val[5]);
    const date = dt.getDate();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return (date < 10 ? '0' + date : date) + ' ' + (months[dt.getMonth()]);
}
export function getISOstring(val) {
    val = val.split(' ');  //works for combination of date and time 
    var PM = val[2].toUpperCase().match('PM') ? true : false;
    var time = val[1].split(/[ :]+/);
    var min = time[1]
    var hour = ""
    if (PM) {
        hour = 12 + parseInt(time[0], 10)
    } else {
        hour = time[0]
    }
    return val[0] + 'T' + hour + ':' + min + ':00.000';
}
export function getISOstring2(val) {
    val = val.split('-');
    val[1] = monthShort.indexOf(val[1]) + 1;
    val[1] = val[1] < 10 ? '0' + val[1] : val[1];
    return val[2] + ',' + val[1] + ',' + val[0];
}

export function get24HoursTime(val) {
    return moment(val, 'YYYY-MM-DD hh:mm:ss a').format("HH:mm");
}

export function get24HoursTimeNew(val) {
    var date = new Date(val);
    return moment(date, 'YYYY-MM-DD hh:mm:ss a').format("HH:mm");
}

export function get24HoursDateTime(val) {
    var date = new Date(val);
    return moment(date, 'YYYY-MM-DD hh:mm:ss a').format("HH:mm, ddd DD MMM");
}

export function isTripStarted(startTime) {
    var stTime = new Date(startTime);
    var stBeforeOneHrs = moment(stTime, 'YYYY-MM-DD hh:mm:ss a').subtract({ 'hours': 1 }).format("YYYYMMDDHHmm");
    var currentTime = moment().format("YYYYMMDDHHmm");

    if (stBeforeOneHrs < currentTime) {
        return true;
    } else {
        return false;
    }
}

export const getString = (key = "", translationsObj = {}) => {
    try {
        if (translationsObj[window.lang][key] !== undefined)
            return translationsObj[window.lang][key];
    } catch (error) {
        console.error(`translation failed for the word: ${key} in ${lang} lang`)
    }

    return "";
}

export const setLang = (ln = "") => {
    if (window.lang == ln)
        return;
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = "lang" + "=" + ln + expires + "; path=/";
    refreshPage();
}

//for split given string by length
export const splitStringByLength = (str, length) => {
    const regex = new RegExp(`.{1,${length}}`, 'g');
    return str.match(regex);
}

export const getWeekDay = (val) => {
    const weekDayArray = { 'Mo': 'Mon', 'Tu': 'Tue', 'We': 'Wed', 'Th': 'Thu', 'Fr': 'Fri', 'Sa': 'Sat', 'Su': 'Sun' };
    return weekDayArray[val];
}

export const getWeekDayIndex = (day) => {
    const weekDayArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return weekDayArray.indexOf(day);
}

export const getDaysOfOperation = (daysOfOperation) => {
    if (daysOfOperation == "Any" || daysOfOperation == "All") {
        return daysOfOperation;
    } else {
        let chunks = splitStringByLength(daysOfOperation, 2);
        let newDaysOfOp = [];
        if (chunks.length) {
            chunks.forEach((el) => {
                newDaysOfOp.push(getWeekDay(el));
            })
        }
        return newDaysOfOp.join(",");
    }
}